import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
    useCategory,
    useElementContext,
} from "@ten24/slatwall-storefront-react-private/global";

const CategorySearchListing = (props) => {
    const { id } = useParams();
    const { CategoryList, ListingBanner, SearchListingStack } =
        useElementContext();
    const navigate = useNavigate();
    const {
        categoryRequest,
        categoryData,
        categoryListRequest,
        crumbCalculator,
        categoryRoute,
        isError,
        errorMessage,
    } = useCategory();

    return (
        <>
            {!!categoryData?.settings?.categoryHTMLTitleString && (
                <Helmet
                    title={categoryData?.settings?.categoryHTMLTitleString}
                />
            )}
            <ListingBanner
                crumbs={crumbCalculator()}
                heading={categoryData?.categoryName}
                images={[categoryData?.imagePath]}
                description={categoryData?.categoryDescription}
                type="category"
            />

            {isError && (
                <div className="container bg-light box-shadow-lg rounded-lg p-5">
                    <div className="row">
                        <div className="alert alert-info" role="alert">
                            {errorMessage}
                        </div>
                    </div>
                </div>
            )}

            <CategoryList
                isFetching={categoryListRequest.isFetching || !categoryRequest.isLoaded}
                onSelect={(urlTitle) => {
                    navigate(`/${categoryRoute}/${urlTitle}`);
                }}
                data={categoryData}
            />
            {(!categoryData?.children ||
                categoryData?.children?.length === 0) && (
                <>
                    <div className="bg-lightgray py-4">
                        <div className="container d-lg-flex justify-content-between py-2 py-lg-3">
                            <div className="order-lg-1 pr-lg-4 text-center">
                                {/* <h1 className="h3 text-dark mb-0 font-accent text-capitalize">{content?.title}</h1> */}
                            </div>
                        </div>
                    </div>
                    <SearchListingStack
                        hide="category"
                        {...props}
                        initPreFilter={{
                            category_slug: id,
                        }}
                    />
                </>
            )}
        </>
    );
};

export { CategorySearchListing };
